module.exports = __webpack_public_path__ + "static/media/iq.be991997.svg";